import { useEffect } from 'react';

interface ExternalRedirectProps {
  to: string;
  replace?: boolean;
}
export function ExternalRedirect({ to, replace = true }: ExternalRedirectProps) {
  useEffect(() => {
    if (replace) {
      window.location.replace(to);
    } else {
      window.location.href = to;
    }
  }, [to, replace]);

  return null;
}
